<template>
   <header>
      <div class="head-left">
        <!-- <a class="logo-lenovo" v-if="islogoLenovo">
          <img src="../images/LenovoLogo-Chinese_POS-Blue-H.png" alt="logo"/>
        </a> -->
        <a v-if="showImage" class="logo">
          <img class="logo-img" v-if="logoUrl !== ''" :src="logoUrl" alt="logo"/>
          <img v-else src="../images/songshuAI_logo.png" alt="logo"/>
        </a>
      </div>
      <div class="header-center" v-if="!this.$route.path.includes('/question')">
        <h1 :class="['center_item',{'active':changeId===2}]" @click="handler(2)">预习中心</h1>
        <!-- <h1 :class="['center_item',{'active':changeId===1}]" @click="handler(1)">测评中心</h1> -->
        <!--<h1 :class="['center_item',{'active':changeId===3}]" @click="handler(3)">练习中心</h1>-->
      </div>
      <div class="user-wrap">
        <span><i class="icon icon-user_name"></i>{{userName}}</span>
        <!-- 跟换落地页后, 退出按钮不在需要 -->
        <!-- <span id="logOut" @click.stop="logOut" v-if="sourceType!=1
         &&!this.$route.path.includes('/question') && Number(loginType) !== 1">
          <i class="icon icon-out"></i>退出
        </span> -->
      </div>
    </header>
</template>

<script>
// 退出按钮及事件不在展示, 以后有需要展开即可
// import api from '@/pages/uc-web/api/api';
import { jsBridgeForSSAI, isApp } from '@/utils/index';
import { getLogo } from '@/utils/auth';

export default {
  data() {
    return {
      sourceType: localStorage.getItem('source_type') || '',
      showImage: false,
      logoUrl: '',
      loginType: 0,
    };
  },
  async created() {
    const accountId = localStorage.getItem('school_id');
    console.log(accountId, '有吗');
    await getLogo(accountId);
    const logo = JSON.parse(sessionStorage.getItem(`${accountId}-ChangeLogoUrl`) || '{}');
    this.logoUrl = logo.logoUrl;
    console.log(this.logoUrl, 'ChangeLogoUrl', logo);
  },
  mounted() {
    this.showImage = true;
    window.getLoginType = this.getLoginType;
    if (isApp()) {
      jsBridgeForSSAI('getData', {
        key: 'loginType',
      }, 'getLoginType');
    }
    console.log(this.sourceType, 'sourceType');
  },
  props: {
    userName: {
      default: '',
      type: String,
    },
    changeId: {
      default: 2,
      type: Number,
    },
  },
  computed: {
    islogoLenovo() {
      const id = localStorage.getItem('school_id') || '';
      return id === '20023' || id === '20022' || id === '20043';
    },
  },
  methods: {
    getLoginType(data) {
      if (data !== undefined) {
        console.log(data, 'apk返回');
        this.loginType = JSON.parse(data).data.loginType;
      }
    },
    // 退出登录
    // async logOut() {
    //   // 如果是在做题页退出
    //   if (this.$route.path.includes('/amt-web') || this.$route.path.includes('/mt-web')) {
    //     this.$toast('成功退出');
    //     setTimeout(() => {
    //       const host = `${window.location.protocol}//${window.location.host}`;
    //       window.location.href = `${host}/uc-web/login`;
    //     }, 1000);
    //   } else { // 如果是在其他页退出
    //     const res = await api.logOut();
    //     if (res) {
    //       if (res.code === 200) {
    //         this.$toast('成功退出');
    //         this.clearUserInfo(); // 清空用户信息
    //         setTimeout(() => {
    //           this.$router.push('/uc-web/login');
    //         }, 1000);
    //       } else {
    //         this.$toast(res.msg);
    //       }
    //     }
    //   }
    //   this.$emit('logOut');
    //   jsBridgeForSSAI('removeData', {
    //     key: 'user_token',
    //   });
    // },
    clearUserInfo() {
      localStorage.clear();
      sessionStorage.clear();
    },
    // 头部切换处理
    handler(activeId) {
      this.activeId = activeId;
      console.log(this.$route.path);
      if (this.$route.path === '/mt-web/question' || this.$route.path === '/amt-web/question') {
        window.location.href = `${window.location.protocol}//${window.location.host}/uc-web/center`;
        localStorage.setItem('changeId', activeId);
      } else {
        this.$emit('handler', activeId);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  position: fixed;
  z-index: 200;
  top: 0;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC-Medium, PingFang SC;
  min-width: 780px;
  padding: 14px 40px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
  background: #fff;
  font-size: 14px;
  .head-left {
    display: flex;
    .logo img {
      width: 200px;
    }
    .logo-img {
      width: 160px !important;
      height: 32px;
    }
    .logo-lenovo{
      margin-top: 5px;
      width: 120px;
    }
  }
  .header-center{
    display: flex;
    flex: 50%;
    top: 0;
    left: 0px;
    height: 64px;
    padding-left: 41px;
    .center_item{
      height: 100%;
      margin-right: 48px;
      line-height: 64px;
      cursor: pointer;
      position:relative;
      font-size: 16px;
      font-weight: 550;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .active {
      color: #1989FA;
      &::before{
        position: absolute;
        content: "";
        left: 0px;
        bottom: 0px;
        width: 64px;
        height: 2px;
        background: #1989FA;
        border-radius: 1px 0px 0px 0px;
      }
      &::after{
        position: absolute;
        content: "";
        left: 30px;
        bottom: 2px;
        width: 0;
        height: 0;
        border-left: 2px solid transparent;
        border-right: 2px solid transparent;
        border-bottom: 2px solid #1989FA;
      }
    }
  }
  .user-wrap {
    display: flex;
    align-items: center;
    #logOut {
      cursor: pointer;
    }
    span {
      margin-left: 24px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .icon {
      vertical-align: middle;
      margin-right: 8px;
      font-size: 20px;
    }
    img {
      vertical-align: middle;
      width: 16px;
      height: 20px;
      margin-right: 5px;
    }
  }
}
</style>
